module.exports = __webpack_public_path__ + "static/media/headwinds.3a31a3c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/headwinds.svg
// module id = 345
// module chunks = 0